const updateActiveColorStopInGradientModel = (gradientColorModel, hslaColor) => {
  const { activeColorStopId } = gradientColorModel;
  const nextValue = [
    String(hslaColor.h),
    String(hslaColor.s),
    String(hslaColor.l),
    String(hslaColor.a ?? 1),
  ];

  return {
    ...gradientColorModel,
    colorStops: gradientColorModel.colorStops.map((colorStop) => {
      if (colorStop.id !== activeColorStopId) {
        return colorStop;
      }

      return {
        ...colorStop,
        value: nextValue,
      };
    }),
  };
};

export default updateActiveColorStopInGradientModel;
